// NativeHudBoot::contourSegment, same 512 samples per cubic (Rhine, MIT).
const rows=[[295,41,273,15,240,15],[221,15,207,23,192,38],[186,43,181,47,176,52],[127,96,103,128,70,128],[38,128,15,101,15,70],[15,39,37,15,70,15],[103,15,127,48,156,75],[182,99,208,128,240,128],[273,128,295,105,295,73]];
const mix=(a,b,t)=>a.map((v,i)=>v+(b[i]-v)*t);
const point=(p,t)=>mix(mix(mix(p[0],p[1],t),mix(p[1],p[2],t),t),mix(mix(p[1],p[2],t),mix(p[2],p[3],t),t),t);
let cursor=[295,73],length=0;
const pieces=rows.map(row=>{const p=[cursor,row.slice(0,2),row.slice(2,4),row.slice(4,6)],begin=length;
 for(let i=1;i<=512;i++){const next=point(p,i/512);length+=Math.hypot(next[0]-cursor[0],next[1]-cursor[1]);cursor=next;}
 return {p,begin,end:length};});
function segment(p,from,to) {
 const a1=mix(p[0],p[1],from),a2=mix(p[1],p[2],from),a3=mix(p[2],p[3],from);
 const b1=mix(a1,a2,from),b2=mix(a2,a3,from),head=mix(b1,b2,from),t=from>=1?1:(to-from)/(1-from);
 const d1=mix(head,b2,t),d2=mix(b2,a3,t),d3=mix(a3,p[3],t),e1=mix(d1,d2,t),e2=mix(d2,d3,t);
 return [head,d1,e1,mix(e1,e2,t)];
}
export function contourSegment(start,amount) {
 if(amount<=0)return '';
 const begin=((start%1)+1)%1*length,end=begin+Math.min(1,amount)*length;
 let path='';
 for(let lap=0;lap<2;lap++)for(const piece of pieces){
  const shift=lap*length,low=Math.max(begin,shift+piece.begin),high=Math.min(end,shift+piece.end),span=piece.end-piece.begin;
  if(high<=low+1e-8)continue;
  const points=segment(piece.p,(low-shift-piece.begin)/span,(high-shift-piece.begin)/span);
  if(!path)path='M'+points[0].join(' ');
  path+='C'+points.slice(1).map(p=>p.join(' ')).join(' ');
 }
 return amount>=.999999?path+'Z':path;
}
